import { InsuranceFinancesPage } from "~/components/insurance-finances/InsuranceFinancesPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/insurance-finances")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo(
      "/insurance-finances",
    ),
  component: InsuranceFinancesPage,
});
